import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {BoardColor, BoardObject, ColorChar} from './board-object.js';
import {CustomLogTag} from '../classes/Constants.js';
import {Puzzle} from './puzzle.js';

/**
 * The environments are the world the game takes place in.
 */
export class Environment extends Component {
    static TypeName = 'environment';

    /**
     * Because there's no array property type, we have to use a string and parse it.
     * String will be something like ygbr for yellow, green, blue, red.
     */
    @property.string('')
    acceptableColorsString = '';

    acceptableColors: BoardColor[];

    private _currentEnvironment = -1;

    start(): void {
        this.acceptableColors = [];
        for (let x = 0; x < this.acceptableColorsString.length; x++) {
            const color = this.acceptableColorsString[x] as ColorChar;
            if (color) {
                this.acceptableColors.push(BoardObject.charToBoardColor(color));
            } else {
                this.engine.log.error(
                    CustomLogTag.Game,
                    `Invalid color in acceptableColorsString(${this.acceptableColorsString[x]})`
                );
            }
        }
        Puzzle.instance.registerResetGameCallback(this._resetGameCallback);
    }

    colorAcceptable(color: BoardColor, numFruitColors: number): boolean {
        let acceptable = false;

        if (numFruitColors == 0) {
            numFruitColors = this.acceptableColors.length;
        }

        for (let x = 0; x < this.acceptableColors.length && x < numFruitColors; x++) {
            if (this.acceptableColors[x] == color) {
                acceptable = true;
                break;
            }
        }
        return acceptable;
    }

    private _resetGameCallback = (puzzle: Puzzle) => {
        //StopSounds();
    };

    showNext() {
        //TODO: Figure out how to implement the environment sequences
        //    this.switchEnvironments((this._currentEnvironment + 1) % environmentSequence.Length);
    }
}
